import {Injectable, signal, effect, PLATFORM_ID, inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({providedIn: 'root'})
export class ThemeService {
    private platformId = inject(PLATFORM_ID);
    private isBrowser = isPlatformBrowser(this.platformId);

    isDark = signal(this.loadSavedTheme());

    constructor() {
        effect(() => this.applyTheme(this.isDark()));
    }

    toggle(): void {
        this.isDark.update(v => !v);
    }

    private applyTheme(dark: boolean): void {
        if (!this.isBrowser) return;

        const body = document.body;
        const html = document.documentElement;

        if (dark) {
            body.classList.add('dark-theme');
            html.setAttribute('data-bs-theme', 'dark');
        } else {
            body.classList.remove('dark-theme');
            html.setAttribute('data-bs-theme', 'light');
        }

        localStorage.setItem('app-theme', dark ? 'dark' : 'light');
    }

    private loadSavedTheme(): boolean {
        if (!this.isBrowser) return false;

        const saved = localStorage.getItem('app-theme');
        if (saved) return saved === 'dark';

        return false;
    }
}
